

















import { Component, Vue, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

@Component({
  name: 'ResortOsNavigation',
})
export default class ResortOsNavigation extends Vue {
  @Getter('cart/cartItemCount') cartItemCount
  private isOpen: boolean = false
  private isScrolled: boolean | null = null
  private authorizedDomain: string = ''
  private topFrameElement: any | null = null
  private sideFrameElement: any | null = null
  private frameContext: Window | null = null

  mounted() {
    // set authorizedDomain to window.location.origin when in production, or the ROS production site when running in local dev environment. When running locally, event messaging between iFrames will NOT work, but navigation will.
    this.authorizedDomain =
      process.env.NODE_ENV === 'development' ? 'https://awro-dev.aspenware.net' : window.location.origin
    this.topFrameElement = document.getElementById('iframe--nav-top')
    this.frameContext = this.topFrameElement ? this.topFrameElement.contentWindow : null
    this.sideFrameElement = document.getElementById('iframe--nav-side')
    this.addEventListeners()
  }

  beforeUnmount() {
    this.removeEventListeners()
  }

  @Watch('isScrolled')
  onScrolled(newState, oldState) {
    if (newState !== oldState) {
      this.emitScrollState(newState)
    }
  }

  @Watch('cartItemCount')
  onCartItemCountChanged(newCount, oldCount) {
    if (newCount !== oldCount) {
      this.emitCartUpdate()
    }
  }

  private addEventListeners(): void {
    window.addEventListener('message', this.handleMessageEvent)
    document.addEventListener('scroll', this.updateScrollState)
    this.sideFrameElement.addEventListener('load', this.handleFrameLoad)
  }

  private emitCartUpdate(): void {
    // Announce to ROS whenever the cart item quantity changes (item added or removed from cart)
    if (this.frameContext) {
      this.frameContext.postMessage('reloadCart', this.authorizedDomain)
    }
  }
  private emitScrollState(state): void {
    // Announce the scroll state to the app header to update the background appropriately on scroll
    if (this.frameContext) {
      this.frameContext.postMessage({ isScrolled: state }, this.authorizedDomain)
    }
  }
  private removeEventListeners(): void {
    window.removeEventListener('message', this.handleMessageEvent)
    document.removeEventListener('scroll', this.updateScrollState)
    this.sideFrameElement.removeEventListener('load', this.handleFrameLoad)
  }
  private setSidebarState(state: boolean): void {
    this.isOpen = state
    const rootEl = document.querySelector('html')
    if (rootEl) {
      if (this.isOpen) {
        rootEl.classList.add('ros-sidebar-open')
      } else {
        rootEl.classList.remove('ros-sidebar-open')
      }
    }
  }
  private handleFrameLoad(): void {
    if (this.sideFrameElement?.contentWindow.location.href === window.location.origin) {
      window.location.replace(window.location.origin)
    }
  }
  private handleMessageEvent(event): void {
    if (event.origin !== this.authorizedDomain) {
      return
    }
    if (event.data === 'emitScrollState') {
      this.updateScrollState()
      this.emitScrollState(this.isViewScrolled)
    }
    // eslint-disable-next-line no-prototype-builtins
    if (event.data.hasOwnProperty('isNavSidebarOpen')) {
      this.setSidebarState(event.data.isNavSidebarOpen)
    }
    // eslint-disable-next-line no-prototype-builtins
    if (event.data.hasOwnProperty('route')) {
      localStorage.setItem('isNavSidebarOpen', 'false')
      this.setSidebarState(false)
      this.loadNopCategory(event.data.route)
    }
  }
  private loadNopCategory(data): void {
    const availableRoutes = this.$router.getRoutes() || []
    const routeData = data
    const routeExistsInRouter = availableRoutes.some((route) => route.name === routeData.name)
    if (routeExistsInRouter) {
      this.$store.dispatch('products/resetSelectedProductDefaults')
      this.$store.dispatch('products/clearSelectedProduct')
      this.$router.push({
        name: routeData.name,
        params: routeData.params,
      })
    } else {
      window.location.href = routeData.params?.subcategory
        ? `/s/${routeData.params.category}/${routeData.params.subcategory}`
        : `/s/${routeData.params.category}`
    }
  }
  private updateScrollState(): void {
    const lastKnownScrollPosition = window.scrollY || 0
    this.isScrolled = lastKnownScrollPosition > 0 ? true : false
  }
  get isViewScrolled(): boolean | null {
    return this.isScrolled
  }
  get isHeroBackground(): boolean {
    const el = document.getElementById('hero')
    return el ? true : false
  }
}
